module.exports = __webpack_public_path__ + "static/og-438aa484d05206b847d4fa9d14c773f6.png";